import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class AfterPlayerEnergyGainEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public newEnergy: number,
  ) {
    super();
  }
}